import React from 'react';
import { size, pickBy } from 'lodash';
import { Link } from 'react-router-dom';
import { useContainer } from 'unstated-next';

import { SelectedRecipes } from '../stateContainers';
import { Recipe, recipes } from '../data/';
import {
    Image,
    Radio,
    Icon,
    Button,
    Card,
    CardProps,
    Container,
    Grid,
    Header,
    List,
    Menu,
    Sticky,
    Accordion,
} from 'semantic-ui-react';
import { FormattedIngredient } from './FormatIngredient';
import { FixedFooter } from './FixedFooter';

function RecipeAccordionItem(
    props: Recipe & {
        id: number,
        activeIndex: number,
        setActiveIndex: (index: number) => void,
    } & Pick<CardProps, 'onClick' | 'color'>,
) {
    const { selectedRecipes, toggleRecipe } = useContainer(SelectedRecipes);
    const isSelected = selectedRecipes[props.id];
    const isActive = props.activeIndex === props.id;

    return (
        <>
            <Accordion.Title
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    ...(props.activeIndex === props.id
                        ? {
                              position: 'sticky',
                              borderBottom: '1px solid rgba(34,36,38,.15)',
                              top: 0,
                              zIndex: 1,
                          }
                        : {}),
                }}
                active={isActive}
                onClick={() => {
                    props.setActiveIndex(isActive ? -1 : props.id);
                }}
            >
                <Icon name="dropdown" />
                <Header style={{ margin: 0, flex: 1, paddingRight: '1em' }} size="tiny">
                    {props.name}
                </Header>
                <Radio
                    toggle
                    checked={isSelected}
                    onChange={(e) => {
                        e.stopPropagation();
                        toggleRecipe(props.id);
                    }}
                />
            </Accordion.Title>
            <Accordion.Content active={isActive}>
                {!!props.url && (
                    <a target="blank" href={props.url}>
                        Source <Icon name="external share" />
                    </a>
                )}
                <Header size="small">Ingredients</Header>
                {props.ingredients.map((ingredientDetails) => {
                    return (
                        <>
                            {size(props.ingredients) > 1 ? (
                                <Header size="tiny">{ingredientDetails.type}</Header>
                            ) : undefined}
                            <List as="ul">
                                {ingredientDetails.materials.map((ingredient) => {
                                    return (
                                        <List.Item
                                            key={ingredient.name}
                                            as="li"
                                            content={<FormattedIngredient {...ingredient} />}
                                        ></List.Item>
                                    );
                                })}
                            </List>
                        </>
                    );
                })}
                {!!size(props.instructions) && <Header size="small">Instructions</Header>}
                {props.instructions.map((instructionDetails) => {
                    return (
                        <>
                            {size(props.instructions) > 1 ? (
                                <Header size="tiny">{instructionDetails.section}</Header>
                            ) : undefined}
                            <List as="ol">
                                {instructionDetails.steps.map((step, idx) => {
                                    return <List.Item as="li" key={idx} content={step} />;
                                })}
                            </List>
                        </>
                    );
                })}
            </Accordion.Content>
        </>
    );
}

export const Home = () => {
    const { selectedRecipes } = useContainer(SelectedRecipes);
    const [activeIndex, setActiveIndex] = React.useState(-1);
    const recipesAsAccordion = (
        <Accordion fluid styled>
            {recipes.map((recipe, idx) => {
                return (
                    <RecipeAccordionItem
                        id={idx}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        {...recipe}
                    />
                );
            })}
        </Accordion>
    );
    return (
        <>
            <Header as="h1">Recipes</Header>
            {recipesAsAccordion}
            {!!size(pickBy(selectedRecipes, (val) => val === true)) && (
                <FixedFooter>
                    <Button size="large" as={Link} fluid color="blue" to="/ingredients">
                        Ingredients
                    </Button>
                </FixedFooter>
            )}
        </>
    );
};
